import { render, staticRenderFns } from "./Surgery.vue?vue&type=template&id=7989fa6f"
import script from "./Surgery.vue?vue&type=script&lang=js"
export * from "./Surgery.vue?vue&type=script&lang=js"
import style0 from "./Surgery.vue?vue&type=style&index=0&id=7989fa6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports